import Api from './Api';

const END_POINT = 'inventories'
export default {
    get_reactive_all(filters = null) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}/reactive`, request);
    },
    async get_allPaginated(filters = null) {
      let request = {
          params: filters
      }
      return await Api.get(`${END_POINT}/reactive-list-paginated`, request);
    },
    async store(reactive) {
        return await Api.post(`/reactive`, reactive);
      },
      async update(reactive) {
        console.log(reactive);
        // return await Api.post(`/reactive/update/${reactive.id}`, reactive);
        return await Api.patch(`/reactive/${reactive.id}`, reactive);
      },
      async delete(reactive) {
        // return await Api.delete(`/reactive/delete/${reactive.id}`)
        return await Api.delete(`/reactive/${reactive.id}`, reactive)
      },
      async change_status(reactive){
        return await Api.patch(`/reactive/${reactive.id}/change-status`, reactive)
      },
      async get_all_categoria(filters = null) {
        return await Api.get(`categories`);
      },
      async get_all_marca(filters = null) {
        let request = {
          params: { active: true },
        };
        return await Api.get(`brands`, request);
      },
      async get_all_unidadMedida(filters = null) {
        let request = {
          params: { active: true },
        };
        return await Api.get(`units`, request);
      },
}